import { createRoot } from 'react-dom/client';
import { XyqarAuthProvider } from '@xyqar/shared-auth';
import App from './app/App.tsx';
import './styles/index.css';

const auth0Cfg = {
  domain:      import.meta.env.VITE_AUTH0_DOMAIN     ?? 'xyqar.us.auth0.com',
  clientId:    import.meta.env.VITE_AUTH0_CLIENT_ID  ?? 'DmFO7zCZxzcaYI4ccZe74ylaUY37G9xL',
  audience:    import.meta.env.VITE_AUTH0_AUDIENCE   ?? 'https://api.xyqar.com',
  redirectUri: window.location.origin,
};

// Canonical domain — redirect Azure SWA URL to custom domain in production
const _XYQAR_CANONICAL_ = 'auditor.xyqar.com';
const _xyqar_host_ = window.location.hostname;
if (_xyqar_host_ !== _XYQAR_CANONICAL_ && _xyqar_host_ !== 'localhost' &&
    !_xyqar_host_.startsWith('127.') && !_xyqar_host_.startsWith('192.168.')) {
  window.location.replace('https://' + _XYQAR_CANONICAL_ +
    window.location.pathname + window.location.search + window.location.hash);
}
createRoot(document.getElementById('root')!).render(
  <XyqarAuthProvider config={auth0Cfg}>
    <App />
  </XyqarAuthProvider>,
);
